import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Custom hook to determine if the current user is a first-time user
 * @param daysThreshold Number of days to consider a user as new (default: 7)
 * @returns Object containing isFirstTimeUser status
 */
export const useFirstTimeUser = (daysThreshold = 7) => {
  const { userProfile } = useAuth();
  const [isFirstTimeUser, setIsFirstTimeUser] = useState<boolean>(false);

  useEffect(() => {
    if (!userProfile) {
      setIsFirstTimeUser(false);
      return;
    }

    // Check if user has lastLogin
    if (!userProfile.lastLogin) {
      setIsFirstTimeUser(true);
      return;
    }

    try {
      // userProfile.lastLogin is already a Date object, no need to call toDate()
      const lastLogin = userProfile.lastLogin;
      const now = new Date();
      
      // Calculate the time difference in days
      const timeDiffInDays = (now.getTime() - lastLogin.getTime()) / (1000 * 60 * 60 * 24);
      
      // User is considered new if their account is less than the threshold days old
      setIsFirstTimeUser(timeDiffInDays < daysThreshold);
    } catch (error) {
      console.error('Error calculating if user is new:', error);
      setIsFirstTimeUser(false);
    }
  }, [userProfile, daysThreshold]);

  return { isFirstTimeUser };
};

export default useFirstTimeUser; 